// extracted by mini-css-extract-plugin
module.exports = {"copyButton":"util-EmbedCopyButton__copyButton--3N2-a","copied":"util-EmbedCopyButton__copied--2wW2V"};